import Grid, { GridItem } from "@/components/layout/Grid";
import { FormCamposProps } from "./FormCamposProps";
import CampoTexto from "@/components/Formulario/CampoTexto";
import CampoCheckbox from "@/components/Formulario/CampoCheckbox";
import CampoSenha from "@/components/Formulario/CampoSenha";

export const FormCamposEmail = ({
    host,
    value,
    onChange,
    fieldErrors,
}: FormCamposProps) => {
    const data = value
        ? JSON.parse(value)
        : {
            email: '',
        };

    return (
        <Grid>
            <GridItem sm={12}>
                {fieldErrors?.['chave_api'] && (
                    <div style={{ color: 'var(--tc-color-danger)' }}>
                        {fieldErrors?.['chave_api']}
                    </div>
                )}
                <CampoTexto
                    label="E-mail"
                    value={data?.email ?? ''}
                    onChange={v => onChange?.(JSON.stringify({ ...data, email: v }))}
                    autoFill="do-not-autofill-please"
                    error={fieldErrors?.['chave_api.email']}
                />
            </GridItem>
            <GridItem sm={12} md={6}>
                <h5>Dados de Entrada (IMAP)</h5>
                <Grid>
                    <GridItem sm={12} md={8}>
                        <CampoTexto
                            label="Servidor SMTP"
                            value={data?.imap?.servidor ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        imap: { ...data?.imap, servidor: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.imap.servidor']}
                        />
                    </GridItem>
                    <GridItem sm={12} md={4}>
                        <CampoTexto
                            label="Porta"
                            value={data?.imap?.porta ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        imap: { ...data?.imap, porta: +v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.imap.porta']}
                        />
                    </GridItem>

                    <GridItem sm={12}>
                        <CampoCheckbox
                            value={data?.imap?.ssl ?? false}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({ ...data, imap: { ...data?.imap, ssl: v } }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.imap.ssl']}
                        >
                            SSL
                        </CampoCheckbox>
                    </GridItem>

                    <GridItem sm={12}>
                        <CampoTexto
                            label="Usuário"
                            value={data?.imap?.usuario ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        imap: { ...data?.imap, usuario: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.imap.usuario']}
                        />
                    </GridItem>

                    <GridItem sm={12}>
                        <CampoSenha
                            label="Senha"
                            value={data?.imap?.senha ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        imap: { ...data?.imap, senha: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.imap.senha']}
                        />
                    </GridItem>
                </Grid>
            </GridItem>
            <GridItem sm={12} md={6}>
                <h5>Dados de Saída (SMTP)</h5>
                <Grid>
                    <GridItem sm={12} md={8}>
                        <CampoTexto
                            label="Servidor SMTP"
                            value={data?.smtp?.servidor ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        smtp: { ...data?.smtp, servidor: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.smtp.servidor']}
                        />
                    </GridItem>
                    <GridItem sm={12} md={4}>
                        <CampoTexto
                            label="Porta"
                            value={data?.smtp?.porta ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        smtp: { ...data?.smtp, porta: +v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.smtp.porta']}
                        />
                    </GridItem>
                    <GridItem sm={12}>
                        <CampoCheckbox
                            name="smtp_ssl"
                            value={data?.smtp?.ssl ?? false}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({ ...data, smtp: { ...data?.smtp, ssl: v } }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.smtp.ssl']}
                        >
                            SSL
                        </CampoCheckbox>
                    </GridItem>

                    <GridItem sm={12}>
                        <CampoTexto
                            label="Usuário"
                            value={data?.smtp?.usuario ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        smtp: { ...data?.smtp, usuario: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.smtp.usuario']}
                        />
                    </GridItem>

                    <GridItem sm={12}>
                        <CampoSenha
                            label="Senha"
                            value={data?.smtp?.senha ?? ''}
                            onChange={v =>
                                onChange?.(
                                    JSON.stringify({
                                        ...data,
                                        smtp: { ...data?.smtp, senha: v },
                                    }),
                                )
                            }
                            autoFill="do-not-autofill-please"
                            error={fieldErrors?.['chave_api.smtp.senha']}
                        />
                    </GridItem>
                </Grid>
            </GridItem>
        </Grid>
    );
};